import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { semanticCapabilities } from '../data/semanticKnowledge';
import { easeOutStrong, fadeUp } from '../utils/motion';
import { SkpWorkflow } from '../components/semantic/SkpWorkflow';
import { SkpResearch } from '../components/semantic/SkpResearch';
import { SkpCapabilityFoundation } from '../components/semantic/SkpCapabilityFoundation';
import { SkpControls } from '../components/semantic/SkpControls';
import { SkpFoundation } from '../components/semantic/SkpFoundation';
import { SkpCTA } from '../components/semantic/SkpCTA';
export function SemanticKnowledgePage() {
  return <>
      <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-24" data-id="element-2275" data-mp="lz1tdenn1vd0">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOutStrong
      }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-2276" data-mp="m0w5q4kugf5h">
          <h1 className="lg:col-span-6 font-heading font-extrabold text-5xl lg:text-6xl text-ink-dark leading-[1.05] tracking-tight" data-id="element-2277" data-mp="yw2c0775214m">
            Semantic Knowledge Platform
          </h1>
          <div className="lg:col-span-6" data-id="element-2278" data-mp="p07pv23phnx3">
            <p className="text-xl text-ink-dark/80 leading-relaxed mb-5" data-id="element-2279" data-mp="k14k1ffwjdo2">
              A configurable system for structured content, shared concepts,
              connected evidence, knowledge graphs, semantic search, and
              AI-assisted research.
            </p>
            <p className="text-lg text-ink-muted leading-relaxed mb-8" data-id="element-2280" data-mp="1crwby0pxpg5l">
              It turns scattered research and content into connected, usable
              knowledge — defining concepts and relationships, linking evidence
              across sources, and pairing AI-assisted discovery with expert
              review.
            </p>
            <a href="#contact" className="inline-flex items-center gap-2 bg-navy hover:bg-navy-light text-white font-medium px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-2281" data-mp="1vo5vh3jluywz">
              Request a Demo
              <ArrowRight size={18} data-id="element-2282" data-mp="3g6gfeycxcszq" />
            </a>
          </div>
        </motion.div>
      </section>

      <section className="bg-surface-bg py-20 lg:py-28" data-id="element-2283" data-mp="3l59vmyjliy3l">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2284" data-mp="3l3p0b6pgjb4o">
          <motion.h2 {...fadeUp} className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight mb-12" data-id="element-2285" data-mp="375ijl3cn3rs8">
            What the platform brings together
          </motion.h2>
          <dl className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 border-t border-line" data-id="element-2286" data-mp="2x95ihkermbng">
            {semanticCapabilities.map(item => <motion.div key={item.title} {...fadeUp} className="border-b border-line py-8" data-id="element-2287" data-mp="vfps8omlayt0">
                <dt className="font-heading font-bold text-xl text-ink-dark mb-2" data-id="element-2288" data-mp="10fu94fretvjr">
                  {item.title}
                </dt>
                <dd className="text-ink-muted leading-relaxed" data-id="element-2289" data-mp="2ky4sa8cwnllg">{item.body}</dd>
              </motion.div>)}
          </dl>
        </div>
      </section>

      <SkpWorkflow data-id="element-2290" data-mp="2umwhw9uhttt7" />
      <SkpResearch data-id="element-2291" data-mp="2uo7tuwy3e7ve" />
      <SkpCapabilityFoundation data-id="element-2292" data-mp="2uopndltde7zm" />
      <SkpControls data-id="element-2293" data-mp="2uozh9khjczal" />
      <SkpFoundation data-id="element-2294" data-mp="2pwppdywv1p5o" />
      <SkpCTA data-id="element-2295" data-mp="2pvep492mizjb" />
    </>;
}